module.exports = __webpack_public_path__ + "img/carousel-productos-6.5a09ff00.jpg";